import { render, staticRenderFns } from "./videoEditor.vue?vue&type=template&id=60788d18&scoped=true&"
import script from "./videoEditor.vue?vue&type=script&lang=js&"
export * from "./videoEditor.vue?vue&type=script&lang=js&"
import style0 from "./videoEditor.vue?vue&type=style&index=0&id=60788d18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60788d18",
  null
  
)

export default component.exports